import Footer from './footer.vue'
import LeftMenu from './LeftMenu.vue'
import RightMain from './RightMain.vue'
// import '../../static/utils/rem.js'
export default {
  name: "App",
  components: {
    Footer,
    LeftMenu,
    RightMain
  },
  data() {
    return {};
  }, 
  created(){
    // const setHtmlFontSize = () => {
    //   const htmlDom = document.getElementsByTagName('html')[0];
    //   let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    //   if (htmlWidth >= 1920) {
    //     htmlWidth = 1920;
    //   }
    //   htmlDom.style.fontSize = 100 * (htmlWidth / 1920) + 'px';
    // };
    // window.onresize = setHtmlFontSize;
    // setHtmlFontSize();
  },
  mounted() {},
  methods: {
    openPage(item){
      window.open(item.enUrl);
    },
  },
};